import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取订单
 * @param data
 */
export const getOrderList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/orderList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取订单列表总数
 * @param data
 */
export const getOrderListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/orderList/count`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取订单详情
 * @param data
 */
export const getSignupDeatil = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signup/getSignupDeatil`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 订单编辑
 * @param data
 */
export const signupUpdateYesLog = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signup/signupUpdateYesLog`,
    method: 'post',
    data
  })

/**
 * 订单保存前验证
 * @param data
 */
export const signupCheck = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signup/signupCheck`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 订单修改记录
 * @param data
 */
export const signupUpdateRecourdList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signupUpdateRecourd/list`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 订单修改记录总数
 * @param data
 */
export const signupUpdateRecourdCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signupUpdateRecourd/listCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取代理结算列表
 * @param data
 */
export const getProxySettlements = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/proxySettlement/getProxySettlements`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取代理结算详情
 * @param data
 */
export const proxySettlementInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/proxySettlement/proxySettlementInfo`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取学籍信息
 * @param data
 */
export const getSchoolRoll = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/signup/stu/info`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取缴费变更记录
 * @param data
 */
export const feesChange = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/fees/change/record/list`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取缴费明细
 * @param data
 */
export const feesList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/stu/pay/record/list`,
    method: 'post',
    data
  })

/**
 * 获取缴费明细总数
 * @param data
 */
export const feesListCout = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/stu/pay/record/list/count`,
    method: 'post',
    data
  })

/**
 * 获取缴费明细详情
 * @param data
 */
export const feesInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/stu/pay/record/info`,
    method: 'post',
    data
  })

/**
 * 获取缴费变更记录详情
 * @param data
 */
export const logInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/fees/change/record/info`,
    method: 'post',
    data
  })

/**
 * 结转异动列表
 * @param data
 */
export const orderFeesChangeList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/feesChange/list`,
    method: 'post',
    data
  })

/**
 * 结转异动总条数
 * @param data
 */
export const orderFeesChangeListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/feesChange/list/count`,
    method: 'post',
    data
  })

/**
 * 结转移动详情
 * @param data
 */
export const orderFeesChangeDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/feesChange/detail`,
    method: 'post',
    data
  })

/**
 * 设置截止支付时间
 * @param data
 */
export const setPayDeadline = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/order/setPayDeadline`,
    method: 'post',
    data
  })

/**
 * 获取入场申请结果列表
 * @param data
 */
export const getEntranceApplyList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/applicant/list`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取入场申请结果列表总数
 * @param data
 */
export const getEntranceApplyListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/applicant/list/count`,
    method: 'post',
    data: qs.stringify(data)
  })
